import angular from 'angular';
import dobInputInlineSave from './dobInputInlineSave';
import './style.scss';

export default angular
  .module('component.dobInputInlineSave', [])
  .component('dobInputInlineSave', dobInputInlineSave).name;
